module.exports = __webpack_public_path__ + "img/img_9.cdeb70d4.png";